module.exports = __webpack_public_path__ + "img/shopIcon15.8f87fdb7.png";